import * as React from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DisplayOnlyField from './fields/DisplayOnlyField';
import HistoryTooltip from './fields/HistoryTooltip';

export default function MuiDatePicker({
  wrapperClasses,
  label,
  value,
  onChange,
  fullWidth,
  disabled,
  dataCy,
  displayOnly,
  displayValue,
  withHistory,
  history = [],
}) {
  // Display-only mode
  if (displayOnly) {
    const displayText = displayValue
      ? dayjs(displayValue).format('DD-MM-YYYY')
      : value
        ? dayjs(value).format('DD-MM-YYYY')
        : '';

    return (
      <div className="flex items-center gap-2 w-full">
        <div className={`${wrapperClasses} flex-1`}>
          <DisplayOnlyField label={label} value={displayText} dataCy={dataCy} />
        </div>
        <HistoryTooltip show={withHistory} history={history} />
      </div>
    );
  }

  return (
    <span
      className={`${wrapperClasses} shadow-sm flex items-center gap-2 ${fullWidth ? 'w-full' : ''}`}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className={` ${fullWidth ? 'w-full' : ''}`}
          sx={{ minWidth: 150 }}
          readOnly={disabled}
          label={label}
          value={value ? dayjs(value) : null}
          onChange={onChange}
          format="DD-MM-YYYY"
          slotProps={{
            textField: {
              'data-cy': dataCy, // Ceci place data-cy sur le MuiTextField qui contient l'input
            },
          }}
        />
      </LocalizationProvider>
      <HistoryTooltip show={withHistory} history={history} />
    </span>
  );
}
